import React from 'react';
import { EVENT_WARNING_TYPES } from '../../../constants/EventWarningTypes';

const DIRECT_CHANNEL_WARNING_TEXT = 'Direct Channel appraisal';

/**
 * @typedef {object} DirectChannelWarningProps
 * @property {Array<*>} [warningTypes]
 */

/**
 * @param {DirectChannelWarningProps} props
 */
const DirectChannelWarning = props => {
  const { warningTypes = [] } = props;
  const hasDirectChannelWarning = warningTypes.includes(EVENT_WARNING_TYPES.DC_EVENT);

  if (!hasDirectChannelWarning) {
    return null;
  }

  return <div className='bold'>{DIRECT_CHANNEL_WARNING_TEXT}</div>;
};

export default DirectChannelWarning;
